export class KYMW1104InputModel {
  // 商品マスタ変更項目カウント
  public goodsMasterEditFlag: boolean = <boolean>false;
  // Pコード
  public pCode: string = <string>'';
  // 商品案内用商品名
  public guideGoodsName: string = <string>'';
  // 商品案内用規格名
  public guideStandardName: string = <string>'';
}
